import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  roles: [],
  isLoading: false,
  isRolesLoading: false,
  error: null,
  rolesError: null,
};

const companyUserSlice = createSlice({
  name: "companyUser",
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    addUser: (state, action) => {
      state.users.push(action.payload);
    },
    updateUser: (state, action) => {
      const index = state.users.findIndex(user => user.id === action.payload.id);
      if (index !== -1) {
        state.users[index] = action.payload;
      }
    },
    removeUser: (state, action) => {
      state.users = state.users.filter(
        (user) => user.id !== action.payload
      );
    },
    
    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    rolesRequestStart: (state) => {
      state.isRolesLoading = true;
      state.rolesError = null;
    },
    rolesRequestSuccess: (state) => {
      state.isRolesLoading = false;
    },
    rolesRequestFailure: (state, action) => {
      state.isRolesLoading = false;
      state.rolesError = action.payload;
    },
    
  },
});

// Export actions
export const {
  setUsers,
  addUser,
  updateUser,
  removeUser,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  setRoles,
  rolesRequestStart,
  rolesRequestSuccess,
  rolesRequestFailure,
} = companyUserSlice.actions;

// Export selectors
export const selectUsers = (state) => state.companyUser.users;
export const selectIsLoading = (state) => state.companyUser.isLoading;
export const selectError = (state) => state.companyUser.error;

export const selectRoles = (state) => state.companyUser.roles;
export const selectIsRolesLoading = (state) => state.companyUser.isRolesLoading;
export const selectRolesError = (state) => state.companyUser.rolesError;

// Export reducer
export default companyUserSlice.reducer;